import { orchestrator } from 'satcheljs';
import { calendarCacheInitializedForAccount } from 'owa-calendar-cache-loader';
import { getDefaultConnectedAccount } from 'owa-accounts-store';
import { logUsage } from 'owa-analytics';
import { getAccountCalendarsLoadStartTime } from '../selectors/getAccountCalendarsLoadStartTime';
import { timestamp } from 'owa-datetime';
import { MILLISECONDS_IN_SECOND } from 'owa-date-constants';
import { toQueryDurationBucket } from '../utils/telemetryBucketUtils';

orchestrator(calendarCacheInitializedForAccount, actionMessage => {
    const { userId } = actionMessage;
    const connectedAccount = getDefaultConnectedAccount();

    if (connectedAccount && connectedAccount.userIdentity === userId) {
        const totalQueryTime =
            (timestamp() - getAccountCalendarsLoadStartTime()) / MILLISECONDS_IN_SECOND;
        const queryTelemetryBucket = toQueryDurationBucket(totalQueryTime);
        logUsage('ConnectedAccountCalendarsListLoad', {
            queryTime: totalQueryTime,
            queryTimeLowerBoundsSeconds_1: queryTelemetryBucket.lowerBoundSeconds,
            queryTimeUpperBoundsSeconds_2: queryTelemetryBucket.upperBoundSeconds,
            accountProviderType_3: connectedAccount.accountProviderType,
        });
    }
});
